import { render, staticRenderFns } from "./ViewCookies.vue?vue&type=template&id=724647fc&scoped=true&"
import script from "./ViewCookies.vue?vue&type=script&lang=js&"
export * from "./ViewCookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724647fc",
  null
  
)

export default component.exports